import { PlanTypeInterface } from "@/entities/Plan/model/plan.types";
import { DepartmentInterface, UserInterface } from "../model/api.types";
import { UserRole } from "../model/constants";

export function filterPlanTypeByUser(
  types: PlanTypeInterface[] | null, 
  userId: number | null, 
  departments: DepartmentInterface[] | null,
  createdByRoles: UserRole | null,
  users: UserInterface[] | null
): PlanTypeInterface[] | null {
  let user = users?.find(u => u.id === userId)

  if (types && types.length > 0 && user && createdByRoles) {
    const userRoles = getUserRole(user.id, user.uf_department, departments);
    const filtredTypes = types.map(t => {
      let f1 = false;
      let f2 = false;
      if (
        (createdByRoles === UserRole.HEADER)) {
        f1 = true;
      }

      if (userRoles === UserRole.HEADER) {
        f2 = true;
      } else if (userRoles === UserRole.EMPLOYEE && t.target_role === 'employee') {
        f2 = true;
      }

      if (f1 && f2) {
        return t;
      }
      return undefined;
    }).filter(Boolean) as PlanTypeInterface[];

    return filtredTypes.length > 0 ? filtredTypes : null;
  }
  return null;
}

export function getUserRole(user_id: number | null, user_department: string | null , departments: DepartmentInterface[] | null): UserRole{
  if (!departments || !user_id) return UserRole.EMPLOYEE;

  let role = UserRole.EMPLOYEE;

  const depsId = parseUserDepartments(user_department);
  depsId.forEach(id => {
    const department = departments.find(d => d.id === id);
    if (!department) return;

    if (department.uf_head === user_id) {
      role = UserRole.HEADER;
    }
  });

  return role;
};

export function parseUserDepartments(user_department: string | null): number[] {
  if (!user_department) return [];
  return user_department
    .split(",")
    .map((id: string) => parseInt(id, 10))
    .filter((id: number) => !isNaN(id));
}

export function parseUsersInDepartment(
  users: UserInterface[] | null, 
  department_id: number | null, 
  isActive: boolean = true, 
  systemAkk: boolean = true
): UserInterface[] {
  if (!users || department_id == null) return [];
  return users.filter(u => 
    parseUserDepartments(u.uf_department).includes(department_id) 
    && (!isActive || u.active === 1)
    && (!systemAkk || u.id !== 12)
  );
}